module.exports = __webpack_public_path__ + "img/neterror.575aca03.png";